<script>
	import { addMinutes, isPast, isWithinInterval } from "date-fns";
	import { getContext } from "svelte";
	import { getEventStyles, readonlyConfig } from "@xbs/lib-scheduler";

	export let event;
	export let calendars = [];
	export let week;
	export let selected;
	$: eventData = event.eventData;
	$: calendar = calendars.find(c => c.id === eventData.type);
	const config = getContext("schedulerConfig");
	const tempaltes = getContext("schedulerTemplates");
	$: ({ readonly, dimPastEvents } = $config);
	$: ({ start_date, end_date } = week);

	$: ({ resize, drag, r } = readonlyConfig(eventData, calendar, readonly));
	$: showResizer =
		resize &&
		isWithinInterval(addMinutes(eventData.end_date, -1), {
			start: start_date,
			end: end_date,
		});
	$: id = eventData?.id;

</script>

{#if !event.position.hideEvent}
	<div
		class="wx-event-calendar-event {r ? 'wx-event-calendar-readonly' : ''} wx-event-calendar-multievent"
		class:wx-event-calendar-selected={$selected?.id === id}
		use:getEventStyles={{ event, backgroundFactor: 'background', calendars, dimPastEvents, isPast: isPast(eventData?.end_date) }}
		data-id={id}
		data-id-type={typeof id}
		data-drag={drag}>
		<svelte:component
			this={tempaltes.multievent}
			event={eventData}
			{calendar} />
		{#if showResizer}
			<i
				data-drag="source"
				data-id-type={typeof id}
				class="wx-event-calendar-resizer wxi-dots-v"
				data-resizer={id} />
		{/if}
	</div>
{/if}

<style>
	.wx-event-calendar-event {
		position: absolute;
		padding: 0 6px;
		border: 1px solid var(--wx-border-color);
		border-radius: 3px;
		color: var(--wx-color-primary-font);
		background-color: var(--wx-background);
		white-space: nowrap;
		overflow: hidden;
		text-overflow: ellipsis;
		display: flex;
		align-items: center;
		cursor: pointer;
		transition: top 0.2s, left 0.2s, width 0.2s;
	}

	.wx-event-calendar-readonly {
		cursor: default;
	}

	.wx-event-calendar-resizer {
		display: flex;
		justify-content: center;
		flex-shrink: 0;
		position: absolute;
		bottom: 0;
		visibility: hidden;
		height: 100%;
		right: 0;
		cursor: w-resize;
		align-items: center;
	}
	.wx-event-calendar-event:hover .wx-event-calendar-resizer {
		visibility: visible;
	}
	.wx-event-calendar-selected {
		box-shadow: var(--wx-popup-shadow);
	}

</style>
